






















import {Component, Prop} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'

@Component({})
export default class TooltipInfoButton extends MixinScreenSize {
  @Prop({type: String, required: false, default: 'i'}) buttonText!: string
  @Prop({
    type: String,
    required: false,
    default: 'rounded-full bg-pale-greenish-blue shadow gap-1',
  })
  buttonClass!: string
}
